<div class="nav-menu">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 mt-4">
        @if (user.photoUrl) {
          <img class="profile-img " [src]="user.photoUrl" alt="photo" />
        }
        @if (user.photoBlob) {
          <img class="profile-img " [src]="user.photoBlob.changingThisBreaksApplicationSecurity" alt="photo" />
        }
        @if (!user.photoBlob && !user.photoUrl) {
          <img class="profile-img " src="assets/img/default-user.png" alt="photo" />
        }
      </div>
      <div class="col-sm-12 mt-2 name">
        {{user.name}}
      </div>
    </div>
  </div>
  <hr />

  <a class="col-lg text-center item d-flex flex-column justify-content-center isMenuItem" routerLink="/dashboard/orders"
    routerLinkActive="active" *checkPermission="{ role: 'viewer'}">
    <div class="menu-item">
      <div class="icon mr-2" aria-label="dashboard" [inlineSVG]="'assets/ico/homepage.svg'"></div>
      <div class="title">{{'sideMenu.homepage' | translate}}</div>
    </div>
    <span></span><span></span><span></span><span></span><span></span><span></span>
  </a>

  <a class="col-lg text-center item d-flex flex-column justify-content-center isMenuItem" routerLink="/errors"
    routerLinkActive="active" *checkPermission="{ role: 'viewer'}">
    <div class="menu-item">
      <div class="icon mr-2" aria-label="dashboard" [inlineSVG]="'assets/ico/exclamation-triangle-regular.svg'"></div>
      <div class="title">{{'sideMenu.errors' | translate}}</div>
      @if (errorCount > 0) {
        <div class="errorCount">{{errorCount}}</div>
      }
    </div>
    <span></span><span></span><span></span><span></span><span></span><span></span>
  </a>

  <div class="position-fixed administration">
    <hr>

      <a class="col-lg text-center item d-flex flex-column justify-content-center isMenuItem"
        (click)="openJiraUsersModal()" routerLinkActive="active" *checkPermission="{ role: 'atlassian_user_manager'}">
        <div class="menu-item">
          <div class="icon mr-2" aria-label="JIRA Users" [inlineSVG]="'assets/ico/jira-icon.svg'"></div>
          <div class="title">{{'sideMenu.jiraUsers' | translate}}</div>
        </div>
        <span></span><span></span><span></span><span></span><span></span><span></span>
      </a>

      <a class="col-lg text-center item d-flex flex-column justify-content-center isMenuItem" routerLink="/administration"
        routerLinkActive="active" *checkPermission="{ role: 'editor'}">
        <div class="menu-item">
          <div class="icon mr-2" aria-label="administration" [inlineSVG]="'assets/ico/cogs.svg'"></div>
          <div class="title">{{'sideMenu.administration' | translate}}</div>
        </div>
        <span></span><span></span><span></span><span></span><span></span><span></span>
      </a>

    </div>

  </div>